import Service from "@/helpers/service";

export default {
  getABCAnalysis() {
    return Service().get("ABCAnalysis");
  },
};
